// @flow
import React, { Children, Fragment, useContext, type Node } from 'react';
import classnames from 'classnames';

import ratioUtils from 'Components/utils/ratios/ratios.utils.js';
import ResponsiveContext from 'Components/utils/responsive/responsiveContext';

import DynamicLink from 'Components/frameworks/dynamic-link/DynamicLink.jsx';
import Image from 'Components/frameworks/image/Image.jsx';
import { TrackClick } from 'Tracking/track-click/TrackClick.jsx';

import { themes } from './ThumbnailPush.themes';

export type ThumbnailPushProps = {
  children?: Node,
  className?: string,
  label: string,
  link?: string,
  theme?: string,
  thumbnail: {
    imageUrl: string,
    ratioKey?: MediaRatios,
  },
  trackingData?: TrackingData,
};

export function ThumbnailPush(props: ThumbnailPushProps) {
  const {
    children,
    className,
    label,
    link,
    theme = 'default',
    thumbnail = {},
    trackingData,
  } = props;

  const { isBrowserGreaterThan } = useContext(ResponsiveContext);

  const { thBody, thLabel, thRoot, thThumbnail } = themes[theme]({
    isBrowserGreaterThan,
  });

  // eslint-disable-next-line clubmed/no-fake-component
  const withLink = node => {
    return link ? (
      <TrackClick
        className="block relative overflow-hidden"
        as={DynamicLink}
        trackingData={trackingData}
        url={link}
      >
        {node}
      </TrackClick>
    ) : (
      node
    );
  };

  return (
    <article className={classnames(className, thRoot, 'image-responsive-cell')}>
      {withLink(
        <Fragment>
          <h2 className={thLabel}>{label}</h2>
          <Image
            {...thumbnail}
            className={thThumbnail}
            ratioKey={thumbnail.ratioKey || ratioUtils.XL}
          />
          {!!Children.count(children) && <div className={thBody}>{children}</div>}
        </Fragment>,
      )}
    </article>
  );
}
